export default __webpack_public_path__ + "static/icons-excavating-f4ffc133fdc7dc124abc39adfc308d0f.png";